import React from 'react';
import {translate} from "react-i18nify";

const hRefValidation = (links, text) => {

    if( ! links )
        return text;

    let newText = text
    Object.keys( links ).forEach( link => {
        console.log( newText, link )
        const a = newText?.split( '##'+link+'##' );
        if( a && a.length > 1 )
            newText = <>{a[0]}<a target={'_blank'} href={ translate( links[link].url ) }>{ translate( links[link].text ) }</a>{ a[1] }</>;
    })
    return newText;
}

const Content = ({title, body, links}) => {

    return <>
        <h2>{ translate( title ) }</h2>
        <div>{ translate( body ).split('\n').map( a => <p>{ hRefValidation( links, a ) }</p>) }</div>
    </>
}

export const ReadingTextWithChapters = ({question, content}) => {

    return <div className={"QuestionElement QuestionTextWithChapters"}>
        {
            content.map( a => <Content title={ a.title } body={ a.body } links={ a.links } />)
        }
    </div>
}